<!-- ChromeManageIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <!-- Outer Chrome ring -->
    <circle
      cx="12"
      cy="12"
      r="9.25"
      stroke="#333333"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

    <!-- Inner center circle -->
    <circle
      cx="12"
      cy="12"
      r="3.25"
      stroke="#333333"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

    <!-- Chrome spoke — right -->
    <line
      x1="15.25"
      y1="12"
      x2="21.25"
      y2="12"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
    />

    <!-- Chrome spoke — lower left -->
    <line
      x1="11.375"
      y1="15.062"
      x2="8.375"
      y2="20.258"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
    />

    <!-- Chrome spoke — upper left -->
    <line
      x1="12.625"
      y1="8.938"
      x2="9.625"
      y2="3.742"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
    />

    <!-- Settings gear — bottom right overlay -->
    <circle
      cx="18"
      cy="18"
      r="3.5"
      fill="white"
      stroke="#333333"
      stroke-width="1.5"
    />
    <circle
      cx="18"
      cy="18"
      r="1.2"
      stroke="#333333"
      stroke-width="1.2"
    />
    <!-- Gear teeth -->
    <line x1="18" y1="14.5" x2="18" y2="15.5" stroke="#333333" stroke-width="1.3" stroke-linecap="round"/>
    <line x1="18" y1="20.5" x2="18" y2="21.5" stroke="#333333" stroke-width="1.3" stroke-linecap="round"/>
    <line x1="14.5" y1="18" x2="15.5" y2="18" stroke="#333333" stroke-width="1.3" stroke-linecap="round"/>
    <line x1="20.5" y1="18" x2="21.5" y2="18" stroke="#333333" stroke-width="1.3" stroke-linecap="round"/>
    <line x1="15.464" y1="15.464" x2="16.172" y2="16.172" stroke="#333333" stroke-width="1.3" stroke-linecap="round"/>
    <line x1="19.828" y1="19.828" x2="20.536" y2="20.536" stroke="#333333" stroke-width="1.3" stroke-linecap="round"/>
    <line x1="20.536" y1="15.464" x2="19.828" y2="16.172" stroke="#333333" stroke-width="1.3" stroke-linecap="round"/>
    <line x1="16.172" y1="19.828" x2="15.464" y2="20.536" stroke="#333333" stroke-width="1.3" stroke-linecap="round"/>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>